export default __webpack_public_path__ + "static/media/connection.69c2178f.svg";